import React from 'react';
import { Quote, Star } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Reveal } from '../hooks/useReveal';
import { SectionTitle } from './About';

const Stars = ({ n }) => (
  <div className="flex gap-1">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} size={16} className={i <= n ? 'text-[#e6b83f]' : 'text-[#4a4436]'} fill={i <= n ? '#e6b83f' : 'none'} />
    ))}
  </div>
);

const Testimonials = () => {
  const { t } = useLanguage();
  const tt = t.testimonials;

  return (
    <section className="section-pad bg-[#14120d]">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <SectionTitle eyebrow={tt.eyebrow} title={tt.title} />
        </Reveal>

        {/* Ratings strip */}
        <Reveal delay={60}>
          <div className="flex flex-wrap items-center justify-center gap-4 mt-10">
            {tt.ratings.map((r) => (
              <a key={r.source} href={r.url} target="_blank" rel="noreferrer"
                className="flex items-center gap-3 px-6 py-4 card-lux rounded-sm">
                <span className="font-deco text-3xl gold-gradient-text font-bold">{r.score}</span>
                <span className="flex flex-col">
                  <Stars n={Math.round(parseFloat(r.score))} />
                  <span className="font-sans-el text-[13px] tracking-wide text-[#c2bbaa] mt-1">{r.source}</span>
                </span>
              </a>
            ))}
          </div>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6 mt-12 max-w-4xl mx-auto">
          {tt.items.map((item, i) => (
            <Reveal key={item.name} delay={i * 90}>
              <div className="card-lux h-full p-8 flex flex-col">
                <div className="flex items-center justify-between">
                  <Quote size={34} className="text-[#e6b83f]/50" />
                  <Stars n={item.rating} />
                </div>
                <p className="font-serif-el italic text-lg text-[#d4cdbe] leading-relaxed mt-4 flex-1">“{item.quote}”</p>
                <div className="mt-6 pt-5 border-t border-[#e6b83f]/15">
                  <div className="font-deco text-base text-[#f7f1e3]">{item.name}</div>
                  <div className="font-sans-el text-[13px] tracking-wide text-[#e6b83f] mt-1">{item.role}</div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <p className="text-center font-sans-el text-[13px] text-[#a19a88] mt-8 italic">{tt.note}</p>
      </div>
    </section>
  );
};

export default Testimonials;
